import {
	teamsSuccess,
	teamsFailure,
	teamsLoading,
	postSuccess,
	postFailure,
	postsLoading,
	postsSuccess,
	postsFailure,
	subpostsLoading,
	subpostsSuccess,
	subpostsFailure,
	creatingTeam,
	createTeamSuccess,
	createTeamFailure,
	sendingTokens,
	sendTokensSuccess,
	sendTokensFailure,
	sendingSubpostTokens,
	sendSubpostTokensFailure,
	sendSubpostTokensSuccess,
	likingPost,
	likePostSuccess,
	likePostFailure,
	likingSubpost,
	likeSubpostSuccess,
	likeSubpostFailure,
	addTeamMembers,
	addTeamMembersSuccess,
	addTeamMembersFailure,
	editTeam as editingTeam,
	editTeamSuccess,
	editTeamFailure,
	deleteTeam as deletingTeam,
	deleteTeamSuccess,
	deleteTeamFailure,
	startSeason as startingSeason,
	startSeasonSuccess,
	startSeasonFailure,
	endSeason as endingSeason,
	endSeasonSuccess,
	endSeasonFailure,
	updateSeason as updatingSeason,
	updateSeasonSuccess,
	updateSeasonFailure,
	deletePost as deletingPost,
	deletePostFailure,
	deletePostSuccess,
	deleteSubpost as deletingSubpost,
	deleteSubpostFailure,
	deleteSubpostSuccess,
} from 'redux/actions';
import * as teamsRequests from 'api/requests';
import { NewTeam } from 'redux/models/newTeam';
import { NewPost } from 'redux/models/newPost';
import { Post } from 'redux/models/post';
import { getUsers } from 'redux/thunks/user';
import { NewSubpost } from 'redux/models/newSubpost';
import { Subpost } from 'redux/models/subpost';
import { addErrorToast, addSuccessToast } from 'components/Toast/toastService';
import { GraphGroupUser } from 'redux/models/graphGroupUser';
import { EditTeam } from 'redux/models/editTeam';
import { EditSeason } from 'redux/models/editSeason';
import { paginatedPostsLoading, paginatedPostsSuccess, teamUserStatsFailure, teamUserStatsLoading, teamUserStatsSuccess } from 'redux/actions/team';
import { TeamStats } from 'redux/models/stat';
import { sendingShoutout, sendingShoutoutFailure, sendingShoutoutSuccess } from 'redux/actions/team';
import { ShoutOut } from 'redux/models/shoutOut';
import { PaginatedPosts } from 'redux/models/paginatedPosts';

export function getTeams() {
	return (dispatch: any) => {
		dispatch(teamsLoading());

		return teamsRequests
			.getTeams()
			.then(data => {
				dispatch(teamsSuccess(data));
			})
			.catch(error => {
				dispatch(teamsFailure(error));
				addErrorToast(dispatch, 'Oh no! An error occured while retrieving the list of teams.');
			});
	};
}

export function getPost(teamId: string) {
	return (dispatch: any) => {
		return teamsRequests
			.getPost(teamId)
			.then(data => {
				dispatch(postSuccess(data));
			})
			.catch(error => {
				dispatch(postFailure(error));
			});
	};
}

export function getPosts(teamId: string, backgroundLoad: boolean = false) {
	return (dispatch: any) => {
		!backgroundLoad && dispatch(postsLoading());

		return teamsRequests
			.getPostsForTeam(teamId)
			.then(data => {
				dispatch(postsSuccess(data));
			})
			.catch(error => {
				dispatch(postsFailure(error));
				addErrorToast(dispatch, 'Oh no! An error occured while retrieving posts.');
			});
	};
}

export function getPaginatedPosts(teamId: string, pageSize: number = 25, continuationToken: any = null, backgroundLoad: boolean = false) {
	return (dispatch: any) => {
		!backgroundLoad && dispatch(paginatedPostsLoading());

		return teamsRequests
			.getPaginatedPostsForTeam(teamId, pageSize, continuationToken)
			.then((result: PaginatedPosts) => {
				dispatch(paginatedPostsSuccess(result.posts, result.pageSize, result.token));
			})
			.catch(error => {
				dispatch(postsFailure(error));
				addErrorToast(dispatch, 'Oh no! An error occured while retrieving posts.');
			});
	};
}

export function getSubposts(postId: string) {
	return (dispatch: any) => {
		dispatch(subpostsLoading());

		return teamsRequests
			.getSubpostsForPost(postId)
			.then(data => {
				dispatch(subpostsSuccess(postId, data));
			})
			.catch(error => {
				dispatch(subpostsFailure(error));
				addErrorToast(dispatch, 'Oh no! An error occured while loading contributions.');
			});
	};
}

export function createTeam(team: NewTeam) {
	return (dispatch: any) => {
		dispatch(creatingTeam());

		return teamsRequests
			.createTeam(team)
			.then(data => {
				dispatch(createTeamSuccess(data));
			})
			.catch(error => {
				dispatch(createTeamFailure(error));
				addErrorToast(dispatch, 'An error occured. Failed to create team.');
			});
	};
}

export function editTeam(team: EditTeam) {
	return (dispatch: any) => {
		dispatch(editingTeam());

		return teamsRequests
			.editTeam(team)
			.then(data => {
				dispatch(editTeamSuccess(data));
				addSuccessToast(dispatch, 'Team info was successfully updated!');
			})
			.catch(error => {
				dispatch(editTeamFailure(error));
				addErrorToast(dispatch, 'An error occured. Failed to edit team.');
			});
	};
}

export function deleteTeam(teamId: string) {
	return (dispatch: any) => {
		dispatch(deletingTeam());

		return teamsRequests
			.deleteTeam(teamId)
			.then(data => {
				dispatch(deleteTeamSuccess(teamId));
				addSuccessToast(dispatch, 'Team was successfully deleted!');
			})
			.catch(error => {
				dispatch(deleteTeamFailure(error));
				addErrorToast(dispatch, 'An error occured. Failed to edit team.');
			});
	};
}

export function sendTokens(newPost: NewPost) {
	return (dispatch: any) => {
		dispatch(sendingTokens());

		return teamsRequests
			.sendTokens(newPost)
			.then((post: Post) => {
				dispatch(sendTokensSuccess(post));
				dispatch(getUsers(post.teamId));
			})
			.catch(error => {
				dispatch(sendTokensFailure(error));
				addErrorToast(dispatch, 'An error occured while sending tokens. Failed to send tokens.');
			});
	};
}

export function sendSubpostTokens(newSubpost: NewSubpost) {
	return (dispatch: any) => {
		dispatch(sendingSubpostTokens());

		return teamsRequests
			.sendSubpostTokens(newSubpost)
			.then((subpost: Subpost) => {
				dispatch(sendSubpostTokensSuccess(subpost));
				dispatch(getUsers(subpost.teamId));
			})
			.catch(error => {
				dispatch(sendSubpostTokensFailure(error));
				addErrorToast(dispatch, 'An error occured while sending tokens. Failed to send tokens.');
			});
	};
}

export function likePost(teamId: string, postId: string) {
	return (dispatch: any) => {
		dispatch(likingPost());

		return teamsRequests
			.likePost(teamId, postId)
			.then((post: Post) => {
				dispatch(likePostSuccess(post));
			})
			.catch(error => {
				dispatch(likePostFailure(error));
				addErrorToast(dispatch, 'An error occured while liking post. Failed to like post.');
			});
	};
}

export function likeSubpost(postId: string, subpostId: string) {
	return (dispatch: any) => {
		dispatch(likingSubpost());

		return teamsRequests
			.likeSubpost(postId, subpostId)
			.then((subpost: Subpost) => {
				dispatch(likeSubpostSuccess(subpost));
			})
			.catch(error => {
				dispatch(likeSubpostFailure(error));
				addErrorToast(dispatch, 'An error occured while liking post. Failed to like post.');
			});
	};
}

export function addMembersToTeam(teamId: string, newMembers: GraphGroupUser[]) {
	return (dispatch: any) => {
		dispatch(addTeamMembers());

		return teamsRequests
			.addTeamMembers(teamId, newMembers)
			.then(() => {
				dispatch(addTeamMembersSuccess());
				dispatch(getUsers(teamId));
				addSuccessToast(dispatch, 'New members were successfully added to the team.');
			})
			.catch((error: any) => {
				dispatch(addTeamMembersFailure(error));
				addErrorToast(dispatch, 'An error occured while add new members to this team. Failed to add memebers.');
			});
	};
}

export function endSeason(season: EditSeason) {
	return (dispatch: any) => {
		dispatch(endingSeason(season));

		return teamsRequests
			.endSeason(season)
			.then(() => {
				dispatch(endSeasonSuccess(season.teamId));
				addSuccessToast(dispatch, 'Season has ended!');
			})
			.catch((error: any) => {
				dispatch(endSeasonFailure(error));
				addErrorToast(dispatch, 'An error occured while ending the season. Failed to end the season.');
			});
	};
}

export function startSeason(teamId: string) {
	return (dispatch: any) => {
		dispatch(startingSeason());

		return teamsRequests
			.startSeason(teamId)
			.then((season: EditSeason) => {
				dispatch(getUsers(teamId));
				dispatch(startSeasonSuccess(season));
				addSuccessToast(dispatch, 'Season has started!');
			})
			.catch((error: any) => {
				dispatch(startSeasonFailure(error));
				addErrorToast(dispatch, 'An error occured while starting the season. Failed to start the season.');
			});
	};
}

export function updateSeason(season: EditSeason) {
	return (dispatch: any) => {
		dispatch(updatingSeason());

		return teamsRequests
			.updateSeason(season)
			.then(() => {
				dispatch(updateSeasonSuccess(season));
				addSuccessToast(dispatch, 'Updated season!');
			})
			.catch((error: any) => {
				dispatch(updateSeasonFailure(error));
				addErrorToast(dispatch, 'An error occured while updating the season. Failed to update the season.');
			});
	};
}

export function deletePost(originalPost: Post) {
	return (dispatch: any) => {
		dispatch(deletingPost());

		return teamsRequests
			.deletePost(originalPost.postId)
			.then((deletedPost: Post) => {
				dispatch(deletePostSuccess(deletedPost, originalPost));
				dispatch(getUsers(originalPost.teamId));
				addSuccessToast(dispatch, 'Post deleted!');
			})
			.catch((error: any) => {
				dispatch(deletePostFailure(error));
				addErrorToast(dispatch, 'An error occured while deleting the post.');
			});
	};
}

export function deleteSubpost(originalSubpost: Subpost) {
	return (dispatch: any) => {
		dispatch(deletingSubpost());

		return teamsRequests
			.deleteSubpost(originalSubpost.subpostId)
			.then((deletedSubpost: Subpost) => {
				dispatch(deleteSubpostSuccess(deletedSubpost, originalSubpost));
				dispatch(getUsers(originalSubpost.teamId));
				addSuccessToast(dispatch, 'Subpost deleted!');
			})
			.catch((error: any) => {
				dispatch(deleteSubpostFailure(error));
				addErrorToast(dispatch, 'An error occured while deleting the subpost.');
			});
	};
}

export function getTeamUserStats(teamId: string, userId: string) {
	return (dispatch: any) => {
		dispatch(teamUserStatsLoading(teamId, userId));

		return teamsRequests
			.getTeamUserStats(teamId, userId)
			.then((stats: TeamStats) => {
				dispatch(teamUserStatsSuccess(stats));
			})
			.catch((error: any) => {
				dispatch(teamUserStatsFailure(error));
				addErrorToast(dispatch, 'An error occured while getting your team stats.');
			});
	};
}

export function sendShoutouts(shoutout: ShoutOut, selectedTeamId: string | null) {
	return (dispatch: any) => {
		dispatch(sendingShoutout());

		return teamsRequests
			.sendShoutOut(shoutout)
			.then((posts: Post[]) => {
				dispatch(sendingShoutoutSuccess(posts, selectedTeamId));
				addSuccessToast(dispatch, 'Your shout-out has been successfully sent!');
			})
			.catch(error => {
				dispatch(sendingShoutoutFailure(error));
				addErrorToast(dispatch, 'An error occured while sending the shout out. Failed to send.');
			});
	};
}
